import http from "@/api/http.js";

export async function getOrdersWarehouse(
  $departmentCode,
  page = 1,
  limitPerPage = 50
) {
  return await http
    .get("orders/set_shipping", {
      params: { department: $departmentCode, page, limitPerPage }
    })
    .then(res => {
      return res.data;
    });
}

export function getPrintBatches(departmentCode) {
  return http
    .get(`/orders/print_batches`, {
      params: { department: departmentCode }
    })
    .then(res => {
      return res.data;
    });
}

export function getPrintBatchesAuto(departmentCode) {
  return http
    .get(`/orders/print_batches_auto`, {
      params: { department: departmentCode }
    })
    .then(res => {
      return res.data;
    });
}

export function createOrderFlag(orderUUID, flag, comment) {
  return http.post("/orders/flag", { orderUUID, comment, flag }).then(res => {
    return res.data;
  });
}

export function updateOrderFromShipstation(orderUUID) {
  return http.get(`/orders/shipstation_update/${orderUUID}`).then(res => {
    return res.data;
  });
}

export function updateOrderStatus(orderUUID, status) {
  return http.put(`/orders/status/${orderUUID}`, { status }).then(res => {
    return res.data;
  });
}

export function touchOrder(orderUUID) {
  return http.put(`/orders/touch/${orderUUID}`).then(res => {
    return res.data;
  });
}

export function updateOrderAddress(orderUUID, addressData) {
  return http
    .put(`/orders/update_address/${orderUUID}`, addressData)
    .then(res => {
      return res.data;
    });
}

export function dispatchOrder(orderUUID, warehouseId) {
  return http
    .put(`/orders/warehouse_dispatch/${orderUUID}`, {
      warehouse_id: warehouseId
    })
    .then(res => {
      return res.data;
    });
}

export function confirmPick(orderUUID, pickedItems) {
  return http
    .put(`/orders/warehouse_confirm_pick/${orderUUID}`, {
      picked_items: pickedItems
    })
    .then(res => {
      return res.data;
    });
}
